import { Stars } from 'lucide-react';
import { ImprovementButtonProps } from './types';
import { Button } from '../../../button';
import LoadingSpinner from '../../../loading-spinner';

export const ImprovementButton = ({
  text,
  handleImprovePrompt,
  isLoading,
  dataOnboarding,
}: ImprovementButtonProps) => {
  return (
    <Button
      data-onboarding={dataOnboarding}
      variant="outline"
      className="hover:bg-prompt-safecomoutrageous-orange/90 mt-2 bg-prompt-safecomoutrageous-orange px-8 text-prompt-safecomwhite hover:text-prompt-safecomwhite"
      onClick={handleImprovePrompt}
      disabled={isLoading}
    >
      {isLoading ? (
        <LoadingSpinner strokeWidth={7} />
      ) : (
        <>
          <Stars />
          {text || 'Get improvement suggestions'}
        </>
      )}
    </Button>
  );
};
